export class SelectedOption {
    private userId: string;
    private creditOptionId: string;
    private loanApplicationId: string;

    constructor(userId?: string, creditOptionId?: string, loanApplicationId?: string)
    constructor(userId: string, creditOptionId: string, loanApplicationId?: string) {
        this.userId = userId;
        this.creditOptionId = creditOptionId;
        this.loanApplicationId = loanApplicationId;
    }

    public static from(selectedOptionJson: object): SelectedOption {
        const selectedOption = new SelectedOption();
        Object.assign(selectedOption, selectedOptionJson);
        return selectedOption;
    }

    public associateLoanApplication(loanId: string): void {
        this.loanApplicationId = loanId;
    }

    public getCreditOptionId(): string {
        return this.creditOptionId;
    }

    public getLoanApplicationId(): string {
        return this.loanApplicationId;
    }
}
